export function getCurrentRestNonce() {
  const nonceEl = typeof document !== "undefined" ? document.getElementById("ww-rest-nonce") : null;
  const nonce = nonceEl ? (nonceEl.value ?? nonceEl.getAttribute("value") ?? "") : "";
  return String(nonce || "").trim();
}

export function getCurrentRestViewer() {
  return getCurrentRestNonce() ? "member" : "guest";
}

let restNonceRefreshPromise = null;

const isInvalidRestNonceResponse = async response => {
  if (!response || response.status !== 403) {
    return false;
  }

  try {
    const payload = await response.clone().json();
    return payload?.code === "rest_cookie_invalid_nonce";
  } catch (error) {
    return false;
  }
};

const refreshRestNonce = async () => {
  if (restNonceRefreshPromise) {
    return restNonceRefreshPromise;
  }

  restNonceRefreshPromise = (async () => {
    const body = new FormData();
    body.append("action", "ww_refresh_rest_nonce");

    const response = await fetch("/wp-admin/admin-ajax.php", {
      method: "POST",
      credentials: "same-origin",
      cache: "no-store",
      body,
    });
    const payload = await response.json();
    const nonce = String(payload?.data?.nonce || "").trim();
    if (!response.ok || payload?.success !== true || !nonce) {
      throw new Error("Unable to renew board session");
    }

    const nonceEl = document.getElementById("ww-rest-nonce");
    if (nonceEl) {
      nonceEl.value = nonce;
      nonceEl.setAttribute("value", nonce);
    }

    return nonce;
  })().finally(() => {
    restNonceRefreshPromise = null;
  });

  return restNonceRefreshPromise;
};

const optionsWithCurrentRestNonce = options => {
  const headers = new Headers(options?.headers || {});
  headers.delete("X-WP-Nonce");
  return restFetchOptions({ ...(options || {}), headers });
};

export async function recoverInvalidRestNonceResponse(response, input, options = {}) {
  if (!(await isInvalidRestNonceResponse(response))) {
    return response;
  }

  await refreshRestNonce();
  return fetch(input, optionsWithCurrentRestNonce(options));
}

export async function restFetchWithNonceRecovery(input, options = {}) {
  const response = await fetch(input, restFetchOptions(options));
  return recoverInvalidRestNonceResponse(response, input, options);
}

export default function restFetchOptions(options = {}) {
  const headers = new Headers(options.headers || {});
  const nonce = getCurrentRestNonce();

  if (nonce && !headers.has("X-WP-Nonce")) {
    headers.set("X-WP-Nonce", nonce);
  }

  return {
    ...options,
    credentials: options.credentials || "same-origin",
    headers,
  };
}
